<template>
  <div class="home">
    <div class="home-bg">
      <!--      <p>北 京 国 际 饭 店</p>-->
      <div class="block" v-if="showHotel">
        <el-date-picker
            v-model="selectTime"
            type="daterange"
            range-separator="|"
            :picker-options="pickerOptions"
            start-placeholder="开始日期 Check in"
            end-placeholder="结束日期 Check out"
        >
        </el-date-picker>
        <div class="channel">
          <el-input v-model="channel" clearable :maxlength="20" placeholder="渠道码 Channel code" />
        </div>
        <el-button type="primary" class="book-in" @click="toBookRoom">立即预订 Book in</el-button>
      </div>
    </div>
    <div class="home-list container">
      <div class="list-item list-item-first">
         <div classs="info">
          <p class="explain">
            坐落于长安街中轴，紫禁城与天天安门广场近在咫尺，王府井繁华、CBD风云尽在邻畔
          </p>
          <p class="explain">
            五百余间客房静沐京城古韵，三十余处雅集会厅涵纳商务风华，其间紫金大厅恢弘两千平米，堪称长安街畔的殿堂级宴聚之所
          </p>
          <p class="explain">
            更坐拥城中至大的康体中心，从容平衡行旅与休憩
          </p>
          <p class="explain">
            凌顶之处，京城唯一的旋转餐厅，360度流转千年城景，更有“谭府”等多元珍膳，让每一次品味，皆是风雅之旅
          </p>
          <p class="explain">
            Nestled along the central axis of Chang'an Avenue, with the Forbidden City and Tian'anmen Square just steps away, this hotel enjoys the vibrant pulse of Wangfujing and the dynamic spirit of the CBD right at its doorstep.
          </p>
          <p class="explain">
            Over five hundred guest rooms are quietly steeped in Beijing's ancient charm, while more than thirty elegant meeting spaces embody modern business sophistication. Among them, the two-thousand-square-meter Grand Hall stands as a grand venue for gatherings on Chang'an Avenue.
          </p>
          <p class="explain">
            Further enhanced by the city's largest fitness center, the hotel gracefully balances travel and tranquility.
          </p>
          <p class="explain">
            At its pinnacle lies Beijing's only revolving restaurant, offering 360-degree views of the capital's millennia-old cityscape. Alongside diverse culinary gems such as "Tan Restaurant," an exclusive Chinese restaurant, every dining experience becomes a journey of refined taste.
          </p>
        </div>
      </div>
      <div class="list-item">
        <div class="info">
          <p class="name">北京国际饭店会议中心</p>
          <p class="name">BEIJING INTERNATIONAL HOTEL CONVENTION CENTER</p>
          <p class="explain">
            北京国际饭店会议中心位于国际饭店主楼东侧，环抱室外花园，地上三层共有20个可灵活使用的会议场地，其中位于三层的紫金大厅场地方正、风格典雅，
            最多可容纳千人的会议活动。除与之相匹配的高速网络信息传输系统、同声传译、多媒体放映机、投影仪等会议设施外，还提供专业录音、摄像等服务，为不同规格、形式的国际化会展活动提供尽善尽美的服务。
          </p>
          <p class="explain">
            The Beijing International Hotel Convention Center, adjacent to the main hotel building, contains more than
            30 multi-functional halls of different sizes and styles. The 2,000-square-meter Grand Hall, located on the
            second floor of the main building, is considered one of Chang’an Avenue’s most high-end venues. The layout
            of the conference venue is centralized and of suitable size. The outdoor garden is located on the first
            floor, offering natural landscape and a peaceful space amidst the hustle and bustle of the city.
          </p>
        </div>
        <a :href="vrUrl" target="_blank">
          <div class="list-item-img-content">
            <img class="img" :src="meetingImg"/>
            <img :src="vrIcon" class="vr-icon">
          </div>
        </a>
      </div>
      <div class="list-item">
        <a :href="vrUrl" target="_blank">
          <div class="list-item-img-content">
            <img class="img" :src="changan"/>
            <img :src="vrIcon" class="vr-icon">
          </div>
        </a>
        <div class="info">
          <p class="name">长安28干式熟成牛排餐厅</p>
          <p class="name">CHANG'AN 28 STEAK HOUSE & BAR</p>
          <p class="explain">
            位于北京国际饭店顶层的长安28干式熟成牛排餐厅是北京市中心唯一的一家旋转餐厅，登临远望，长安街在脚下笔直舒展，360度俯瞰京城变迁，从故宫到CBD、从鸟巢、水立方到四通八达的北京胡同，视野辽阔，尽收眼底。依托五星级酒店的服务标准与品质追求，旋转餐厅的干式熟成牛排套餐，更是为老饕津津乐道的美食推荐。这种牛排中的顶级享受，只有坐在北京国际饭店顶层、旋转着体验，才能相得益彰。
          </p>
          <p class="explain">
            Located on the 28th floor of the Beijing International Hotel, Chang'an 28 Steak House & Bar is the only
            revolving restaurant in the center of Beijing. It stands at a height of 108 meters and boasts a 360-degree
            view of Beijing. There, one can enjoy the classic afternoon tea, fusion cuisine, Dry-aged Beef, and have
            plenty of other wonderful experiences.
          </p>
        </div>
      </div>
      <div class="list-item">
        <div class="info">
          <p class="name">谭府餐厅</p>
          <p class="name">TAN RESTAURANT</p>
          <p class="explain">
            位于饭店三层的谭府餐厅以经营谭氏官府菜为主，其著名的菜品有谭八珍等，特聘名厨主理，同时兼备川湘菜肴供您享用，丰俭由人。谭府餐厅由零点餐厅和谭府小院包间组成；零点餐厅布局优雅、环境怡人、清净温馨；谭府小院幽静私密，厅堂布局优美，深得中式庭院建筑之灵气，景观、餐具、菜品处处体现中华文化底蕴。假山荷塘，藻井回廊，丝竹鸟语不绝于耳，花美菜香“欲破禅”，来到谭府步步精彩，口口经典！
          </p>
          <p class="explain">
            Located on the 3rd floor, Tan Restaurant is characterized by special Tan cuisine (feudal official dishes).
            When appreciating exquisite rockeries, lotus ponds, coffers and corridors, listening to traditional Chinese
            music accompanied by birds’ singing, smelling the fragrance from beautiful flowers and delicious dishes.
          </p>
        </div>
        <a :href="vrUrl" target="_blank">
          <div class="list-item-img-content">
            <img class="img" :src="office"/>
            <img :src="vrIcon" class="vr-icon">
          </div>
        </a>
      </div>
    </div>
    <div class="about-us" @click="toAboutUs"></div>
    <div class="concat-us">
      <div class="container concat-us-inner">
        <div class="concat-us-left">
          <h2>联系我们</h2>
          <div class="concat-us-item">
            地址：中国北京建国门内大街9号 100005
          </div>
          <div class="concat-us-item">
            电话：+86 10 6512 6688
          </div>
          <div class="concat-us-item">
            邮箱：service@bih.com.cn
          </div>
          <div class="concat-us-item">
            微信：订阅号WeChat subscription account <br/>
            <div class="concat-us-fwh">
              <div>
                服务号WeChat service account
              </div>
              <div class="fwh-qrcode-box">
                <div class="fwh-qrcode-box-it">
                  <img src="@/assets/img/ewm1.png" alt="" srcset=""/>
                  <p>BIH65126688</p>
                </div>
                <div class="fwh-qrcode-box-it">
                  <img src="@/assets/img/ewm2.png" alt="" srcset=""/>
                  <p>INTERNATIONALHOTELBJ</p>
                </div>
                <div class="fwh-qrcode-box-it">
                  <img src="@/assets/img/tiktok_code.png" alt="" srcset=""/>
                  <p>Tik Tok</p>
                </div>
              </div>
            </div>
          </div>
          <div class="concat-us-item">
            预订：+86 10 6512 6688
          </div>
          <div class="concat-us-item">
            <div>邮箱：rsvn@bih.com.cn</div>
            <div style="padding-left:44px">booking@bih.com.cn</div>
          </div>
        </div>
        <div class="concat-us-right">
          <h2>CONTACT</h2>
          <div class="concat-us-item">
            ADDRESS: No. 9 Jianguomennei Avenue Beijing, P.R. China 100005
          </div>
          <div class="concat-us-item">
            PHONE: +86 10 6512 6688
          </div>
          <div class="concat-us-item">
            E-MAIL: service@bih.com.cn
          </div>
          <div class="concat-us-item">
            RESERVATION TEAM
          </div>
          <div class="concat-us-item">
            PHONE: +86 10 6512 6688
          </div>
          <div class="concat-us-item">
            <div>E-MAIL: rsvn@bih.com.cn</div>
            <div style="padding-left:60px">booking@bih.com.cn</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "home",
  data() {
    return {
      vrUrl: 'https://scheme.huixiaoer.com/report/multi-hotelvr?site_id=86104543&space_id=',
      imgSrc: require("@/assets/img/bg.png"),
      vrIcon: require("@/assets/img/vr/vr.png"),
      meetingImg: require("@/assets/img/meeting.png"),
      changan: require("@/assets/img/changan.png"),
      office: require("@/assets/img/office.png"),
      selectTime: [],
      showHotel: false, //显示酒店预定
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      aboutUsInfo: "",
      // 渠道码
      channel: ''
    };
  },
  props: {},
  computed: {},
  components: {},
  mounted() {
    this.getTenantService();
  },
  methods: {
    toAboutUs() {
      sessionStorage.setItem("aboutUsInfo", this.aboutUsInfo);
      this.$router.push(`/brief-introduction`);
      // this.$router.push(`/home/about-us`);
    },
    toBookRoom() {
      if (this.selectTime.length == 0) {
        this.$message.error("请选择日期");
        return;
      }
      let channelReg = /^[a-zA-Z0-9]{6,20}$/;
      if (this.channel && !channelReg.test(this.channel)) {
        this.$message.error("请填写正确的渠道码");
        return;
      }
      this.$router.push({
        path: "/home/book-room",
        query: {
          startTime: this.formatDate(this.selectTime[0]),
          endTime: this.formatDate(this.selectTime[1]),
          channel: this.channel
        },
      });
    },
    async getTenantService() {
      try {
        let {data} = await this.$api.getTenantService();
        this.aboutUsInfo = data.showDetail;
        const homeFunctionCodes = JSON.parse(data.homeFunctionCodes) || [];
        const bookRoom = homeFunctionCodes.find(element => element.name == '订房');
        if (bookRoom != undefined && bookRoom.isCheck == 1) {
          this.showHotel = true;
        } else {
          this.showHotel = false;
        }
      } catch (error) {
        console.log(error);
      }
    },
    formatDate(date) {
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      return `${year}-${month}-${day > 9 ? day : "0" + day}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  .home-bg {
    width: 100%;
    height: 516px;
    background: url("https://slhk-noggin.tos-cn-beijing.volces.com/slds-file/images/b04f180956874204948e4dc2fc5cbeaa.png") 0 0 / 100% 100% no-repeat;
    display: flex;
    align-items: center;
    flex-direction: column;

    p {
      font-size: 60px;
      font-weight: 400;
      color: #ffffff;
      margin: 114px 0 141px 0;
    }

    .block {
      display: flex;
      margin-top: 315px;
    }

    .channel {
      height: 80px;
      line-height: 1;
      background: #ffffff;
      font-size: 20px;
      color: #333333;
      border: none;
      position: relative;
      &::before {
        content: '|';
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1;
        line-height: 76px;
        font-size: 20px;
        font-weight: 400;
        color: #999999;
      }
      /deep/ .el-input__inner {
        height: 80px;
        font-size: 18px;
        font-weight: bold;
        border: none;
        padding-left: 30px;
        text-align: center;
        min-width: 60px;
      }
    }

    .book-in {
      width: 240px;
      height: 80px;
      background: #333333;
      font-size: 20px;

      font-weight: bold;
      color: #ffffff;
    }
  }

  .home-list {
    margin-bottom: 120px;

    .list-item {
      width: 100%;
      height: 468px;
      display: flex;
      margin-top: 89px;

      .info {
        width: 440px;
        height: 100%;
        padding: 0 34px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        .name {
          font-size: 18px;

          font-weight: bold;
          color: #333333;
        }

        .explain {
          font-size: 15px;

          font-weight: 400;
          color: #333333;
          line-height: 22px;
        }
      }

      .list-item-img-content {
        width: 760px;
        height: 468px;
        position: relative;
        box-sizing: border-box;
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
        overflow: hidden;

        &:hover .img {
          transform: scale(1.01);
        }

        &:before {
          content: "";
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0;
          right: 0;
          background: rgba(0, 0, 0, 0.1);
          z-index: 1;
          cursor: pointer;
        }

        .img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          -o-object-fit: cover;
          transition: ease-in 0.5s;
        }
        .vr-icon{
          width: 80px;
          height: auto;
          cursor: pointer;
          position: absolute;
          z-index: 2;
          right: 40px;
          top: 40px;
        }
      }
    }


    .list-item-first {
      height: auto;

      .explain {
        margin-bottom: 15px;
        font-size: 15px;
        font-weight: 400;
        color: #333333;
        line-height: 22px;

        &:nth-of-type(8) {
          margin-bottom: 0;
        }
      }
    }
  }

  .about-us {
    width: 100%;
    height: 200px;
    background: url("~@/assets/img/about-us.png") 0 0 / 100% 100% no-repeat;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    cursor: pointer;
  }

  .concat-us {
    height: 522px;
    background: #333333;

    .concat-us-inner {
      font-size: 15px;
      font-weight: bold;
      color: #b1b1b1;
      padding: 40px 82px;
      display: flex;
      justify-content: space-between;

      h2 {
        margin-bottom: 40px;
      }

      .concat-us-item {
        line-height: 30px;
      }

      .concat-us-fwh {
        padding-left: 44px;

        .fwh-qrcode-box {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          margin-top: 20px;

          .fwh-qrcode-box-it {
            margin-right: 30px;
          }

          img {
            width: 107px;
            height: 107px;
            margin: 0 auto;
          }

          p {
            text-align: center;
            font-size: 15px;
            font-weight: 400;
            color: #b1b1b1;
            margin-top: 12px;
          }
        }
      }
    }
  }

  /deep/ .el-date-editor {
    &.el-input__inner {
      width: 500px;
      height: 80px;
      border: none;
      position: relative;
    }

    .el-range-separator {
      width: 10px;
      line-height: 72px;
      font-size: 18px;
      font-weight: 400;
      color: #999999;
    }

    .el-range__icon,
    .el-range__close-icon {
      width: 50px;
      font-size: 24px;
      line-height: 72px;
    }

    .el-range__close-icon {

      position: absolute;
      right: 0;
      top: 0;
      z-index: 1;
    }

    .el-range-input {
      font-size: 18px;
      font-weight: bold;
      color: #333333;
      width: 220px;
    }
  }
}
</style>
